import { HiX } from "react-icons/hi";
import SidebarLinks from "./components/SidebarLinks";
import routes from "routes/routes";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`fixed left-0 top-0 z-50 flex h-screen min-w-72 flex-col bg-white shadow-md transition-transform duration-300 dark:bg-navy-800 dark:text-white md:z-50 lg:z-50 xl:z-0 ${
        open ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Close button */}
      <button
        className="absolute right-4 top-4 rounded-full p-2 hover:bg-gray-100 dark:hover:bg-navy-700 xl:hidden"
        onClick={onClose}
      >
        <HiX className="h-5 w-5 text-primary dark:text-white" />
      </button>

      {/* Logo */}
      <div className="flex justify-start p-3">
        <div className="primary-gradient rounded-lg p-3  shadow-md">
          <img src="/logo.avif" alt="Logo" className="w-36" />
        </div>
      </div>

      <div className="my-4 h-px bg-gray-300 dark:bg-white/30" />

      {/* Navigation links */}
      <nav className="flex-1 overflow-y-auto px-4">
        <SidebarLinks routes={routes} />
      </nav>
    </div>
  );
};

export default Sidebar;
